<div class="listTile noSelect">
  <mat-icon *ngIf="!!leadingIcon">{{leadingIcon}}</mat-icon>
  <div class="column">
    <div class="listTileTitle">
      <h4>{{title}}</h4>
      <mat-icon *ngIf="!!trailingIcon">{{trailingIcon}}</mat-icon>
    </div>
    <p *ngIf="!!subtitle">{{subtitle}}</p>
  </div>
</div>